



















import { Component, Vue } from 'vue-property-decorator';
import { LoggingResponse, LogItem } from '@service/solr/logging';

@Component
export default class Discover extends Vue {
  private loggingResponse: LoggingResponse = {
    history: {
      numFound: 0,
      start: 0,
      docs: [],
    },
    info: {
      buffer: 0,
      last: 0,
      levels: [],
      threshold: '',
    },
    responseHeader: {
      status: 0,
      QTime: 0,
    },
    watcher: '',
  };

  private loggingClassMap: { [key: string]: string } = {
    warn: 'yellow',
    error: 'red',
    fatal: 'red',
  };

  private rowClassName({ row }: { row: LogItem; rowIndex: number }) {
    return this.loggingClassMap[row.level.toLowerCase()] || '';
  }

  private refresh() {
    this.$service.solr.logging
      .logs()
      .then((response) => {
        this.loggingResponse = response.data;
      })
      .catch((err) => this.$notify.error(err.message));
  }

  created() {
    this.refresh();
  }
}
